export default (value) => {
  const MAX_URL_LENGTH = 2080;

  return value?.length > MAX_URL_LENGTH ? `${value.slice(0, MAX_URL_LENGTH - 3)}...` : value;
};
